var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manuel-ban-modal wrapper" },
    [
      _vm.internalBanModalVisible
        ? _c(
            "Modal2",
            {
              staticClass: "custom-ban-modal",
              attrs: {
                title: _vm.$t("message.banModalTitle"),
                "ok-text": "Yasakla",
                "cancel-text": _vm.$t("message.cancel"),
              },
              on: {
                cancel: _vm.closeModal,
                ok: function ($event) {
                  return _vm.suppressionProcess(_vm.type, _vm.value)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "ban-form-container" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "vertical" } },
                    [
                      _c("div", { staticClass: "ban-form-header" }, [
                        _c("span", { staticClass: "ban-form-title" }, [
                          _vm._v(
                            "\n                       " +
                              _vm._s(_vm.$t("message.banModalDescription")) +
                              " \n                    "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("message.platform") } },
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'",
                                },
                              ],
                              staticClass: "platform-select",
                              attrs: {
                                id: "type",
                                placeholder: _vm.$t("message.selectPlatform"),
                              },
                              model: {
                                value: _vm.type,
                                callback: function ($$v) {
                                  _vm.type = $$v
                                },
                                expression: "type",
                              },
                            },
                            _vm._l(_vm.types, function (item) {
                              return _c(
                                "a-select-option",
                                { key: item.id, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("chatbotv2.value") } },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            class: { "has-error": _vm.errors.has("value") },
                            attrs: {
                              placeholder: _vm.getPlaceholderForType,
                              name: "value",
                            },
                            model: {
                              value: _vm.value,
                              callback: function ($$v) {
                                _vm.value = $$v
                              },
                              expression: "value",
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has("value")
                            ? _c(
                                "div",
                                { staticClass: "ant-form-explain error-text" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.errors.first("value")) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "help-text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getHelpTextForType) +
                                "\n                    "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ban-options" },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "Yasaklama Seçenekleri" } },
                            [
                              _c(
                                "div",
                                { staticClass: "ban-option-container" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "switch-option",
                                      class: { "active-option": _vm.inbound },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "switch-header" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "switch-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.sendingAllow")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("a-switch", {
                                            staticClass: "ml-2 mr-2",
                                            attrs: {
                                              "checked-children": "✖",
                                              "un-checked-children": "✔",
                                            },
                                            model: {
                                              value: _vm.inbound,
                                              callback: function ($$v) {
                                                _vm.inbound = $$v
                                              },
                                              expression: "inbound",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "switch-status" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class: _vm.inbound
                                                ? "status-blocked"
                                                : "status-allowed",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.inbound
                                                      ? _vm.$t(
                                                          "message.bannedUser"
                                                        )
                                                      : _vm.$t(
                                                          "message.unbannedUser"
                                                        )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "switch-option",
                                      class: { "active-option": _vm.outbound },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "switch-header" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "switch-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.receiving")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("a-switch", {
                                            staticClass: "ml-2 mr-2",
                                            attrs: {
                                              "checked-children": "✖",
                                              "un-checked-children": "✔",
                                            },
                                            model: {
                                              value: _vm.outbound,
                                              callback: function ($$v) {
                                                _vm.outbound = $$v
                                              },
                                              expression: "outbound",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "switch-status" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              class: _vm.outbound
                                                ? "status-blocked"
                                                : "status-allowed",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.outbound
                                                      ? _vm.$t(
                                                          "message.bannedUser"
                                                        )
                                                      : _vm.$t(
                                                          "message.unbannedUser"
                                                        )
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }